import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { money } from "@/lib/api";
import { useFav } from "@/context/FavoritesContext";

export default function ProductCard({ product, index = 0 }) {
  const { has, toggle } = useFav();
  const p = product;
  const img = p.images?.[0];
  const img2 = p.images?.[1];
  const inStock = p.in_stock !== false && (p.total_stock === undefined || p.total_stock > 0);
  const onSale = p.sale_price && p.sale_price < p.price;
  const fav = has(p.id);

  return (
    <div className="pcard group rise" style={{ animationDelay: `${(index % 8) * 60}ms` }} data-testid={`product-card-${p.id}`}>
      <Link to={`/produit/${p.id}`} className="block relative overflow-hidden bg-[#f4f4f6]">
        <div className="aspect-[3/4] relative">
          {img && <img src={img} alt={p.name} loading="lazy" className="primary absolute inset-0 w-full h-full object-cover" />}
          {img2 && <img src={img2} alt="" loading="lazy" className="secondary absolute inset-0 w-full h-full object-cover" />}
          {!inStock && (
            <div className="absolute inset-0 bg-white/60 flex items-center justify-center">
              <span className="over text-[0.7rem] bg-[#0A0A0A] text-white px-4 py-2">Épuisé</span>
            </div>
          )}
          {p.badges?.[0] && (
            <span className="absolute top-3 left-3 over text-[0.6rem] bg-white/90 border border-[#D4AF37]/50 px-3 py-1.5 text-[#0A0A0A]">
              {p.badges[0]}
            </span>
          )}
          {onSale && (
            <span className="absolute top-3 left-3 over text-[0.6rem] bg-[#E0115F] text-white px-3 py-1.5" style={{ top: p.badges?.[0] ? "2.6rem" : "0.75rem" }}>
              Promo
            </span>
          )}
        </div>
      </Link>
      <button
        onClick={() => toggle(p.id)}
        data-testid={`fav-toggle-${p.id}`}
        className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/85 backdrop-blur-sm hover:bg-white transition-colors"
        aria-label="Favori"
      >
        <Heart size={16} className={fav ? "fill-[#E0115F] text-[#E0115F]" : "text-[#0A0A0A]"} />
      </button>

      <div className="pt-4 pb-6">
        <Link to={`/createur/${p.seller_id}`} className="over text-[0.62rem] text-[#8E8E93] hover:text-[#D4AF37] transition-colors">
          {p.creator_name}
        </Link>
        <Link to={`/produit/${p.id}`}>
          <h3 className="font-display text-lg leading-snug mt-1 text-[#111] hover:text-[#E0115F] transition-colors">{p.name}</h3>
        </Link>
        <div className="mt-1.5 flex items-baseline gap-2">
          <span className={`text-sm ${onSale ? "text-[#E0115F]" : "text-[#111]"}`}>{money(onSale ? p.sale_price : p.price)}</span>
          {onSale && <span className="text-xs text-[#8E8E93] line-through">{money(p.price)}</span>}
        </div>
      </div>
    </div>
  );
}
